export const SET_BRAND = 'SET_BRAND'
